var path = '/pages/vouchers/templates/views/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vouchers/templates/views/list.tpl.html
// module id = 2333
// module chunks = 1